import { HealthBanner as HealthBannerUi } from "@jti/ui/eva-components/Footer/components/HealthBanner";

import type { healthBannerInputs } from "./HealthBanner.builder";

export type HealthBannerProps = BuilderComponentProps<typeof healthBannerInputs>;

export const HealthBanner = ({ content, variant, noPadding, customProperties }: HealthBannerProps) => {
  return (
    <HealthBannerUi
      content={content}
      variant={variant}
      noPadding={noPadding}
      backgroundColor={customProperties?.backgroundColor}
      borderColor={customProperties?.borderColor}
      borderWidth={customProperties?.borderWidth}
      fontFamily={customProperties?.fontFamily}
      height={customProperties?.height}
      width={customProperties?.width}
      textColor={customProperties?.textColor}
      fontSize={customProperties?.fontSize}
    />
  );
};
